"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvStringArrayValidator = void 0;
const zod_1 = require("zod");
exports.csvStringArrayValidator = zod_1.z.string().refine(value => {
    if (typeof value !== 'string')
        return false;
    const parts = value.split(',');
    return parts.every(part => part.trim() !== ''); // Ensure no empty parts after splitting
}, {
    message: 'Value must be a valid comma-separated string',
});
